/* RESPONSIBLE TEAM: team-inbox */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class SearchController extends Controller {
  queryParams = ['qa_mode', 'backfill_status'];

  @tracked qa_mode?: string;
  @tracked backfill_status?: string;
}
